import React from 'react';
import { Dialog, Icon } from '@blueprintjs/core';
import Flexbox from 'flexbox-react';
import "./AddOptionDialog.css";


const AddOptionDialog = ({isOpen,onClose,onSelect}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      className="add-option-dialog"
      portalContainer={document.body}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
    >
      <div className="add-option-dialog-content">

        {/* Header */}
        <div className="add-option-dialog-header">
          <div>
            <h2 className="add-option-dialog-title">
              What would you like to add?
            </h2>

            <p className="add-option-dialog-subtitle">
              Choose an option to continue. You’ll enter the details next.
            </p>
          </div>

          <button
            type="button"
            className="add-option-dialog-close"
            onClick={onClose}
          >
            <Icon icon="cross" size={18} />
          </button>
        </div>

        {/* Options */}
        <Flexbox
          className="add-option-dialog-options"
          gap="12px"
        >

          {/* Competency */}
          <button
            type="button"
            className="add-option-card selected push-10-r"
            onClick={() => onSelect('competency')}
          >
            <div className="add-option-icon competency">
              <Icon icon="briefcase" size={18} />
            </div>

            <div className="add-option-card-content">
              <div className="add-option-card-title">
                Competency
              </div>

              <div className="add-option-card-description">
                Create a competency section and add questions to evaluate it.
              </div>
            </div>
          </button>

          {/* Direct Report */}
          <button
            type="button"
            className="add-option-card"
            onClick={() => onSelect('direct_report')}
          >
            <div className="add-option-icon direct-report">
              <Icon icon="add" size={18} />
            </div>

            <div className="add-option-card-content">
              <div className="add-option-card-title">
                Rater Category
              </div>

              <div className="add-option-card-description">
                Add an Rater type who will evaluate employee feedback setup you want to manage.
              </div>
            </div>
          </button>

        </Flexbox>
      </div>
    </Dialog>
  );
};

export default AddOptionDialog;